import { useNavigate } from 'react-router';

import { SIGNALRAPIS } from '../../constants/global';
import { pageurl } from '../../constants/pageurl';
import { type ResultNotificationSignalR, useSignalR } from '../../hooks/signalr';
import { NotificationBellAlertSVG, NotificationBellSVG } from '../reusable/svgs';
import { NotificationDropDownItem } from './drop-down-list';

export const NotificationDropDownMenu = ({ id }: { id: string }) => {
	const navigate = useNavigate();

	// const { notification } = useSignalR<INotification>(SIGNALRAPIS.DEFAULT);

	// const { notification: broadCastNotification } = useSignalR<EmailResultRequestSignalR>(SIGNALRAPIS.BROADCAST);

	const { notification: agentNotification } = useSignalR<ResultNotificationSignalR>(SIGNALRAPIS.AGENTSTATS);

	const handleNotificationAction = () => {
		navigate(pageurl.NOTIFICATIONS);
	};

	const isNotification = !!agentNotification;

	return (
		<div className='dropdown'>
			<div
				className='dropdown-toggle cursor-pointer'
				id={id}
				data-toggle='dropdown'
				aria-haspopup='true'
				aria-expanded='false'
			>
				{isNotification ? <NotificationBellAlertSVG /> : <NotificationBellSVG />}
			</div>

			<ul
				className='dropdown-menu dm-menu p-1'
				aria-labelledby={id}
			>
				<NotificationDropDownItem
					notification={agentNotification?.title || ''}
					handleNotificationAction={handleNotificationAction}
				/>

				{/* <NotificationDropDownItem
					// notification={broadCastNotification?.Title || 'Election Result successfuly sent to your email.'}
					notification={broadCastNotification?.Title || ''}
					cta={
						<p
							className='font-11 text-decoration-underline m-0 text-success'
							onClick={handleDownload}
						>
							Download link
						</p>
					}
				/> */}
			</ul>
		</div>
	);
};
